export type FilterKey =
  | 'nameFilter'
  | 'jobTitleFilter'
  | 'decisionFilter'
  | 'interviewerFilter'
  | 'interviewTypeFilter'
  | 'eventFilter'
export const NAME_FILTER_KEY: FilterKey = 'nameFilter'
export const JOB_TITLE_FILTER_KEY: FilterKey = 'jobTitleFilter'
export const DECISION_FILTER_KEY: FilterKey = 'decisionFilter'
export const INTERVIEWER_FILTER_KEY: FilterKey = 'interviewerFilter'
export const INTERVIEW_TYPE_FILTER_KEY: FilterKey = 'interviewTypeFilter'
export const EVENT_FILTER_KEY: FilterKey = 'eventFilter'

export const cleanFilters = () => {
  localStorage.removeItem(NAME_FILTER_KEY)
  localStorage.removeItem(JOB_TITLE_FILTER_KEY)
  localStorage.removeItem(DECISION_FILTER_KEY)
  localStorage.removeItem(INTERVIEWER_FILTER_KEY)
  localStorage.removeItem(INTERVIEW_TYPE_FILTER_KEY)
  localStorage.removeItem(EVENT_FILTER_KEY)
}
